import { createFileRoute } from '@tanstack/react-router'

import { BatchesTabsPage } from '@/pages/batches/BatchTabs.page'

export const Route = createFileRoute(
  '/_auth/$companyId/spaces/$spaceId/projects/$projectId/batches',
)({
  component: BatchesTabsPage,
})
